import {Grid, GridItem} from '@travel-frontend/ui-components';

type Props = {
  main: React.ReactNode;
  aside: React.ReactNode;
};

export const LayoutTwoColumn: React.FunctionComponent<Props> = ({
  main,
  aside,
}) => {
  return (
    <Grid lg={12} xl={12} md={8} sm={4} xs={2}>
      <GridItem lg={3} xl={3}>
        {aside}
      </GridItem>
      <GridItem xl={9} lg={9} md={8} sm={4} xs={2}>
        {main}
      </GridItem>
    </Grid>
  );
};
